export const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
export const previewUrl = (id) => new URL(`images/ht_node_preview_img_${encodeURIComponent(id)}.jpg`, new URL('./', location.href)).href;
export function applyPreviewFallback(image, nodes) {
 const match = /ht_node_preview_img_([^/]+)\.jpg$/.exec(new URL(image.src).pathname);
 const node = nodes.find((node) => node.id === decodeURIComponent(match?.[1] || ''));
 if (!image.dataset.fallbackTried && node?.fallback) {
  image.dataset.fallbackTried = 'true'; image.hidden = false; image.src = node.fallback; return true;
 }
 return false;
}
export function captureDate(value) {
 const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(value || '');
 return match ? `${match[3]}-${match[1].padStart(2, '0')}-${match[2].padStart(2, '0')}` : null;
}
export async function readTour(player) {
 const response = await fetch(new URL('pano.xml', location.href));
 if (!response.ok) throw new Error(`Tour XML: ${response.status}`);
 const xml = new DOMParser().parseFromString(await response.text(), 'application/xml');
 if (xml.querySelector('parsererror')) throw new Error('Invalid tour XML');
 const ids = new Set(player.getNodeIds());
 return [...xml.querySelectorAll('tour > panorama')].filter((el) => ids.has(el.getAttribute('id'))).map((el, index) => {
  const id = el.getAttribute('id'), data = el.querySelector('userdata');
  const get = (key) => data?.getAttribute(key) || '';
  // Recognize the current aerial-title typo without changing source content.
  const aerial = get('tags').split('|').includes('aerial') || /εναέρι|ενέρια|aerial/i.test(get('title'));
  const lat = get('latitude'), lon = get('longitude');
  const coords = lat && lon && Number.isFinite(Number(lat)) && Number.isFinite(Number(lon)) ? [Number(lon), Number(lat)] : null;
  const input = el.querySelector('input'), tileTemplate = input?.getAttribute('leveltileurl');
  const fallback = tileTemplate ? new URL(tileTemplate.replace('%c','0').replace('%l',String(Math.max(0,input.querySelectorAll('level').length-1))).replace('%x','0').replace('%y','0'),location.href).href : null;
  return {id, index, title: player.getNodeUserdata(id)?.title || get('title') || id, description: get('description'), author: get('author'), date: captureDate(get('datetime')), aerial, coords, fallback,
   links: [...new Set([...el.querySelectorAll('hotspots > hotspot')].map((hs) => /^\{(.+)\}$/.exec(hs.getAttribute('url') || '')?.[1]).filter((id) => ids.has(id)))],
  };
 });
}
export function toGeoJSON(nodes) {
 return {type: 'FeatureCollection', features: nodes.filter((node) => node.coords).map((node) => ({type: 'Feature', id: node.id,
  geometry: {type: 'Point', coordinates: node.coords}, properties: {node_id: node.id, label: node.title, capture_type: node.aerial ? 'aerial' : 'ground', captured_at: node.date},
 }))};
}
